import React, { useState, useRef, useEffect } from 'react';
import { User, FileText, History, Wallet, CheckCircle, Clock, Shield, Camera, Phone, X, Upload, HelpCircle, ChevronLeft, ChevronRight, ChevronDown, Loader2, AlertTriangle, ArrowLeft, Users, Copy, Gift, DollarSign, TrendingUp, Lock, CreditCard } from 'lucide-react';
import { track } from '../utils/tracker';
import { ReactComponent as LimitsIcon } from '../exchange-app-icons/limits.svg';
import { ReactComponent as ZayavkiIcon } from '../exchange-app-icons/zayavki.svg';
import { ReactComponent as VerificationIcon } from '../exchange-app-icons/verification-icon.svg';
import { ReactComponent as StatsIcon } from '../exchange-app-icons/stats.svg';
import { ReactComponent as VerifiedCheckIcon } from '../exchange-app-icons/verified-check.svg';

// СБП Icon Component
const SBPIcon = ({ className = "w-8 h-10" }) => (
  <svg className={className} viewBox="0 0 97 120" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 26.12l14.532 25.975v15.844L.017 93.863 0 26.12z" fill="#5B57A2"/>
    <path d="M55.797 42.643l13.617-8.346 27.868-.026-41.485 25.414V42.643z" fill="#D90751"/>
    <path d="M55.72 25.967l.077 34.39-14.566-8.95V0l14.49 25.967z" fill="#FAB718"/>
    <path d="M97.282 34.271l-27.869.026-13.693-8.33L41.231 0l56.05 34.271z" fill="#ED6F26"/>
    <path d="M55.797 94.007V77.322l-14.566-8.78.008 51.458 14.558-25.993z" fill="#63B22F"/>
    <path d="M69.38 85.737L14.531 52.095 0 26.12l97.223 59.583-27.844.034z" fill="#1487C9"/>
    <path d="M41.24 120l14.556-25.993 13.583-8.27 27.843-.034L41.24 120z" fill="#017F36"/>
    <path d="M.017 93.863l41.333-25.32-13.896-8.526-12.922 7.922L.017 93.863z" fill="#984995"/>
  </svg>
);

// ВТБ Icon Component
const VTBIcon = ({ className = "w-12 h-5" }) => (
  <svg className={className} viewBox="0 0 92 33" xmlns="http://www.w3.org/2000/svg">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g>
        <g>
          <g>
            <path d="M6.25065367,0 L4.68701481,4.28311036 L26.3555573,4.28311036 L27.9191962,0 L6.25065367,0 Z M3.90470765,6.423693 L2.34106879,10.7058308 L24.0096113,10.7058308 L25.5732502,6.423693 L3.90470765,6.423693 Z M1.56363886,12.847386 L0,17.1295238 L21.6685425,17.1295238 L23.231206,12.847386 L1.56363886,12.847386 Z" fill="#38BDF8"/>
            <path d="M46.0659305,18.7617116 L46.0659305,18.8520825 C47.0561913,19.215552 48.002112,19.8511271 48.497735,20.2592855 C50.0289442,21.5304356 50.7048834,23.2097442 50.7048834,25.3885751 C50.7048834,28.975602 48.8130419,31.5625912 45.7052982,32.3799011 C44.7593775,32.6520067 43.7691167,32.7433706 41.9216153,32.7433706 L32.5097041,32.7433706 L32.5097041,6.50603633 L40.8416891,6.50603633 C42.5532145,6.50603633 43.7237914,6.59640716 44.7593775,6.86851275 C47.7774558,7.68582259 49.7589627,9.77428262 49.7589627,13.0872178 C49.7589627,14.8578903 49.1283488,16.3564572 48.0927627,17.3545087 C47.642465,17.808349 47.0118512,18.3535533 46.0659305,18.7617116 Z M37.7339454,21.5304356 L37.7339454,28.4303977 L41.3373122,28.4303977 C42.4172384,28.4303977 43.4084845,28.3400269 44.129749,27.6587698 C44.8500282,26.9775128 45.1653351,26.1155141 45.1653351,24.9804167 C45.1653351,24.118418 44.9396936,23.3011081 44.489396,22.711215 C43.7237914,21.7578524 42.7778706,21.5304356 41.1569961,21.5304356 L37.7339454,21.5304356 Z M37.6886201,16.9910392 L40.6160476,16.9910392 C41.516643,16.9910392 41.9669407,16.9910392 42.4172384,16.8549864 C43.634126,16.4915169 44.3997305,15.4030945 44.3997305,13.9045276 C44.3997305,12.1348482 43.5888006,11.3622273 42.4172384,10.9997508 C41.9216153,10.863698 41.4269776,10.8180161 40.4357315,10.8180161 L37.6886201,10.8180161 L37.6886201,16.9910392 Z M58.5412454,32.7433706 L58.5412454,10.9083869 L51.0201903,10.9083869 L51.0201903,6.50603633 L71.918141,6.50603633 L70.4322572,10.9083869 L63.7654868,10.9083869 L63.7654868,32.7433706 L58.5412454,32.7433706 Z M73.5390156,32.7433706 L73.5390156,6.50603633 L90.4739526,6.50603633 L88.9880688,10.9083869 L78.7189169,10.9083869 L78.7189169,16.7189336 L82.9075721,16.7189336 C86.2852974,16.7189336 88.0421481,17.5362434 89.2580504,18.5799769 C90.2039711,19.3972867 91.8248457,21.2126481 91.8248457,24.799675 C91.8248457,28.3400269 90.1586457,30.291441 88.7624273,31.2904856 C87.1415527,32.4245899 85.4300274,32.7433706 81.9616514,32.7433706 L73.5390156,32.7433706 Z M78.7189169,28.3400269 L82.6375906,28.3400269 C84.1234744,28.3400269 85.0240698,27.9765574 85.6546836,27.1592475 C85.9699905,26.7510892 86.4202882,26.0241502 86.4202882,24.6626291 C86.4202882,23.3011081 85.9699905,22.3477455 85.0693951,21.6664884 C84.5294321,21.2583301 83.8081675,21.0319064 82.5922652,21.0319064 L78.7189169,21.0319064 L78.7189169,28.3400269 Z" fill="#60A5FA"/>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

// Проверка ночного времени (0:00 - 8:30)
const useNightTimeWarning = () => {
  const [isNightTime, setIsNightTime] = useState(false);

  useEffect(() => {
    const checkTime = () => {
      const now = new Date();
      // Московское время (UTC+3)
      const msk = new Date(now.getTime() + (now.getTimezoneOffset() + 180) * 60000);
      const totalMinutes = msk.getHours() * 60 + msk.getMinutes();
      setIsNightTime(totalMinutes < 510); // 0:00 - 8:30 МСК (8*60+30=510)
    };

    checkTime();
    const interval = setInterval(checkTime, 60000);
    return () => clearInterval(interval);
  }, []);

  return isNightTime;
};

const NightTimeWarning = () => (
  <div className="bg-amber-500/10 rounded-2xl p-4 mb-4 border border-amber-500/30 flex items-start gap-3">
    <AlertTriangle className="w-5 h-5 text-amber-400 flex-shrink-0 mt-0.5" />
    <p className="text-sm text-amber-300">
      В период с 0:00 до 8:30 могут возникнуть задержки в обработке заявки
    </p>
  </div>
);

// Passport Camera Overlay Component
const PassportCamera = ({ onCapture, onClose, pageNumber = 1, tg }) => {
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const [stream, setStream] = useState(null);
  const [ready, setReady] = useState(false);
  const [error, setError] = useState('');
  const [capturedPreview, setCapturedPreview] = useState(null); // preview URL
  const [capturedFile, setCapturedFile] = useState(null); // File object

  // Перехватываем Telegram BackButton — при нажатии закрываем камеру (возврат в KYC)
  useEffect(() => {
    if (!tg?.BackButton) return;
    const handleBack = () => {
      if (capturedPreview) {
        // Если на экране предпросмотра — возвращаемся к съёмке
        handleRetake();
      } else {
        stream?.getTracks().forEach(t => t.stop());
        onClose();
      }
    };
    tg.BackButton.onClick(handleBack);
    return () => {
      tg.BackButton.offClick(handleBack);
    };
  }, [tg, onClose, stream, capturedPreview]);

  const startCamera = async () => {
    try {
      const mediaStream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: 'environment', width: { ideal: 1920 }, height: { ideal: 1080 } },
        audio: false,
      });
      setStream(mediaStream);
      if (videoRef.current) {
        videoRef.current.srcObject = mediaStream;
        videoRef.current.onloadedmetadata = () => setReady(true);
      }
    } catch (err) {
      setError('Не удалось открыть камеру. Разрешите доступ к камере.');
    }
  };

  useEffect(() => {
    let mounted = true;
    const init = async () => {
      try {
        const mediaStream = await navigator.mediaDevices.getUserMedia({
          video: { facingMode: 'environment', width: { ideal: 1920 }, height: { ideal: 1080 } },
          audio: false,
        });
        if (!mounted) { mediaStream.getTracks().forEach(t => t.stop()); return; }
        setStream(mediaStream);
        if (videoRef.current) {
          videoRef.current.srcObject = mediaStream;
          videoRef.current.onloadedmetadata = () => setReady(true);
        }
      } catch (err) {
        if (mounted) setError('Не удалось открыть камеру. Разрешите доступ к камере.');
      }
    };
    init();
    return () => { mounted = false; stream?.getTracks().forEach(t => t.stop()); };
  }, []);

  const capture = () => {
    if (!videoRef.current || !canvasRef.current) return;
    const video = videoRef.current;
    const canvas = canvasRef.current;
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(video, 0, 0);
    const previewUrl = canvas.toDataURL('image/jpeg', 0.92);
    canvas.toBlob((blob) => {
      if (blob) {
        const file = new File([blob], `passport_${pageNumber}.jpg`, { type: 'image/jpeg' });
        setCapturedFile(file);
        setCapturedPreview(previewUrl);
        stream?.getTracks().forEach(t => t.stop());
      }
    }, 'image/jpeg', 0.92);
  };

  const handleRetake = () => {
    setCapturedPreview(null);
    setCapturedFile(null);
    setReady(false);
    startCamera();
  };

  const handleConfirm = () => {
    if (capturedFile) {
      onCapture(capturedFile);
    }
  };

  const handleClose = () => {
    stream?.getTracks().forEach(t => t.stop());
    onClose();
  };

  const galleryInputRef = useRef(null);

  const handleGallerySelect = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    stream?.getTracks().forEach(t => t.stop());
    const previewUrl = URL.createObjectURL(file);
    setCapturedFile(file);
    setCapturedPreview(previewUrl);
  };

  // Экран предпросмотра
  if (capturedPreview) {
    return (
      <div className="fixed inset-0 z-[100] bg-black flex flex-col">
        {/* Title */}
        <div className="shrink-0 pb-3 px-6 text-center" style={{ paddingTop: 'calc(env(safe-area-inset-top, 0px) + 95px)' }}>
          <h2 className="text-white text-xl font-bold leading-tight">
            Проверьте фото
          </h2>
        </div>

        {/* Preview image */}
        <div className="flex-1 relative mx-4 rounded-2xl" style={{ overflow: 'hidden', isolation: 'isolate', WebkitMaskImage: '-webkit-radial-gradient(white, black)' }}>
          <img
            src={capturedPreview}
            alt="Preview"
            className="absolute inset-0 w-full h-full object-cover"
          />
        </div>

        {/* Warning block */}
        <div className="mx-4 mt-3 bg-red-500/15 rounded-2xl p-4 border border-red-500/30">
          <p className="text-red-400 text-base font-bold text-center mb-2">
            &#9888; Перепроверьте перед отправкой!
          </p>
          <div className="space-y-1.5">
            <p className="text-gray-200 text-sm text-center">Если фото некачественное — заявку <span className="text-red-300 font-semibold">отклонят</span></p>
            <div className="flex flex-col gap-1 pt-1">
              <span className="text-gray-300 text-xs">✓ ФИО, серия и номер чётко читаются</span>
              <span className="text-gray-300 text-xs">✓ Нет бликов, теней и засветов</span>
              <span className="text-gray-300 text-xs">✓ Страница целиком в кадре</span>
            </div>
          </div>
        </div>

        {/* Buttons */}
        <div className="shrink-0 pt-3 pb-2 px-4 flex items-center justify-center gap-3" style={{ paddingBottom: 'calc(max(env(safe-area-inset-bottom, 0px), var(--tg-safe-area-inset-bottom, 0px), 48px) + var(--tg-content-safe-area-inset-bottom, 0px))' }}>
          <button
            onClick={handleRetake}
            className="flex-1 h-14 rounded-2xl bg-gray-800 flex items-center justify-center active:scale-95 transition-transform"
          >
            <span className="text-white text-sm font-semibold">Переснять</span>
          </button>
          <button
            onClick={handleConfirm}
            className="flex-1 h-14 rounded-2xl bg-purple-600 flex items-center justify-center active:scale-95 transition-transform"
          >
            <span className="text-white text-sm font-semibold">Продолжить</span>
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="fixed inset-0 z-[100] bg-black flex flex-col">
      {/* Title section */}
      <div className="shrink-0 pb-3 px-6 text-center" style={{ paddingTop: 'calc(env(safe-area-inset-top, 0px) + 95px)' }}>
        <h2 className="text-white text-xl font-bold leading-tight">
          {pageNumber === 1 ? 'Разместите главный разворот паспорта в кадре' : 'Разместите страницу с пропиской в кадре'}
        </h2>
        <p className="text-gray-500 text-sm mt-2">
          Мы используем эту информацию, чтобы подтвердить вашу личность
        </p>
      </div>

      {/* Camera view */}
      <div className="flex-1 relative mx-4 rounded-2xl" style={{ overflow: 'hidden', isolation: 'isolate', WebkitMaskImage: '-webkit-radial-gradient(white, black)' }}>
        {error ? (
          <div className="w-full h-full flex items-center justify-center bg-gray-900">
            <div className="text-center p-6">
              <Camera className="w-12 h-12 text-gray-500 mx-auto mb-3" />
              <p className="text-gray-400 text-sm">{error}</p>
              <button onClick={handleClose} className="mt-4 px-6 py-2 bg-gray-800 rounded-xl text-white text-sm">
                Назад
              </button>
            </div>
          </div>
        ) : (
          <>
            <video
              ref={videoRef}
              autoPlay
              playsInline
              muted
              className="absolute inset-0 w-full h-full object-cover"
            />
            {/* Passport overlay */}
            {pageNumber === 1 && (
              <div className="absolute inset-0 pointer-events-none">
                <img
                  src="/passportfirtpage.png"
                  alt=""
                  className="w-full h-full opacity-50"
                  style={{ objectFit: 'contain', mixBlendMode: 'multiply' }}
                  draggable={false}
                />
              </div>
            )}
            {/* Registration page overlay */}
            {pageNumber === 2 && (
              <div className="absolute inset-0 pointer-events-none">
                <img
                  src="/propiska.png"
                  alt=""
                  className="w-full h-full opacity-50"
                  style={{ objectFit: 'contain', mixBlendMode: 'multiply' }}
                  draggable={false}
                />
              </div>
            )}
          </>
        )}
        <canvas ref={canvasRef} className="hidden" />
      </div>

      {/* Bottom bar with 3 buttons */}
      {!error && (
        <div className="shrink-0 pt-3 pb-2 px-4 flex items-center justify-center gap-3" style={{ paddingBottom: 'calc(max(env(safe-area-inset-bottom, 0px), var(--tg-safe-area-inset-bottom, 0px), 48px) + var(--tg-content-safe-area-inset-bottom, 0px))' }}>
          {/* Gallery button */}
          <button
            onClick={() => galleryInputRef.current?.click()}
            className="w-14 h-14 rounded-2xl bg-gray-800/80 flex items-center justify-center active:scale-95 transition-transform"
          >
            <Upload className="w-6 h-6 text-gray-400" />
          </button>
          <input
            ref={galleryInputRef}
            type="file"
            accept="image/*"
            onChange={handleGallerySelect}
            className="hidden"
          />

          {/* Capture button */}
          <button
            onClick={capture}
            disabled={!ready}
            className="flex-1 max-w-[200px] h-14 rounded-2xl bg-purple-600 flex items-center justify-center disabled:opacity-30 active:scale-95 transition-transform"
          >
            <Camera className="w-7 h-7 text-white" />
          </button>

          {/* Close button */}
          <button
            onClick={handleClose}
            className="w-14 h-14 rounded-2xl bg-gray-800/80 flex items-center justify-center active:scale-95 transition-transform"
          >
            <X className="w-6 h-6 text-gray-400" />
          </button>
        </div>
      )}
    </div>
  );
};

// KYC Modal Component with Altyn Integration - Professional Design
const KYCModal = ({
  isOpen,
  onClose,
  tg,
  setUserPhone,
  uploadDocument,
  registerClient,
  sendVerificationCode,
  confirmVerification,
  checkVerificationStatus,
  apiUrl,
  userId,
}) => {
  const [step, setStep] = useState(1);
  const [phoneInput, setPhoneInput] = useState('');
  const [verificationCode, setVerificationCode] = useState('');
  const [sendAs, setSendAs] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [rejectedReason, setRejectedReason] = useState(null);
  const wsRef = useRef(null);
  const pingRef = useRef(null);
  
  const [passportPhotos, setPassportPhotos] = useState([]);
  const [selfiePhoto, setSelfiePhoto] = useState(null);
  const [uploadedFileKeys, setUploadedFileKeys] = useState({
    document: null,
    address: null,
    selfie: null,
  });
  
  const passportInputRef = useRef(null);
  const selfieInputRef = useRef(null);
  const [isKycInfoOpen, setIsKycInfoOpen] = useState(false);
  const [showCamera, setShowCamera] = useState(false);
  const [cameraPage, setCameraPage] = useState(1);
  const isNightTime = useNightTimeWarning();

  const handlePassportUpload = async (e) => {
    const files = Array.from(e.target.files);
    if (files.length === 0) return;
    track('kyc_photo_taken', { docType: 'passport' });

    setIsLoading(true);
    setError('');
    
    try {
      for (let i = 0; i < Math.min(files.length, 2 - passportPhotos.length); i++) {
        const file = files[i];
        const result = await uploadDocument(file);
        
        if (result.success) {
          const newPhoto = {
            file,
            preview: URL.createObjectURL(file),
            fileKey: result.fileKey,
          };
          
          setPassportPhotos(prev => {
            const updated = [...prev, newPhoto].slice(0, 2);
            if (updated.length === 1) {
              setUploadedFileKeys(prev => ({ ...prev, document: result.fileKey }));
            } else if (updated.length === 2) {
              setUploadedFileKeys(prev => ({ ...prev, address: result.fileKey }));
            }
            return updated;
          });
          track('kyc_photo_uploaded', { docType: 'passport' });
        }
      }
    } catch (err) {
      setError(err.message || 'Ошибка загрузки документа');
    } finally {
      setIsLoading(false);
    }
  };

  const handleSelfieUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    track('kyc_photo_taken', { docType: 'selfie' });

    setIsLoading(true);
    setError('');

    try {
      const result = await uploadDocument(file);

      if (result.success) {
        setSelfiePhoto({
          file,
          preview: URL.createObjectURL(file),
          fileKey: result.fileKey,
        });
        setUploadedFileKeys(prev => ({ ...prev, selfie: result.fileKey }));
        track('kyc_photo_uploaded', { docType: 'selfie' });
      }
    } catch (err) {
      setError(err.message || 'Ошибка загрузки селфи');
    } finally {
      setIsLoading(false);
    }
  };

  const handleCameraCapture = async (file) => {
    setShowCamera(false);
    track('kyc_camera_open');
    setIsLoading(true);
    setError('');
    try {
      const result = await uploadDocument(file);
      if (result.success) {
        const newPhoto = {
          file,
          preview: URL.createObjectURL(file),
          fileKey: result.fileKey,
        };
        setPassportPhotos(prev => {
          const updated = [...prev, newPhoto].slice(0, 2);
          if (updated.length === 1) {
            setUploadedFileKeys(prev => ({ ...prev, document: result.fileKey }));
          } else if (updated.length === 2) {
            setUploadedFileKeys(prev => ({ ...prev, address: result.fileKey }));
          }
          return updated;
        });
      }
    } catch (err) {
      setError(err.message || 'Ошибка загрузки документа');
    } finally {
      setIsLoading(false);
    }
  };

  const openCamera = (page) => {
    setCameraPage(page);
    setShowCamera(true);
  };

  const removePassportPhoto = (index) => {
    setPassportPhotos(prev => prev.filter((_, i) => i !== index));
    if (index === 0) {
      setUploadedFileKeys(prev => ({ ...prev, document: prev.address, address: null }));
    } else {
      setUploadedFileKeys(prev => ({ ...prev, address: null }));
    }
  };

  const handleRegisterAndSendCode = async () => {
    if (phoneInput.length !== 10) {
      setError('Введите корректный номер телефона (10 цифр)');
      return;
    }
    if (passportPhotos.length < 2) {
      setError('Загрузите 2 фотографии паспорта');
      return;
    }
    if (!selfiePhoto) {
      setError('Загрузите селфи-фото');
      return;
    }

    setIsLoading(true);
    setError('');
    track('kyc_phone_entered');

    try {
      const phone = '+7' + phoneInput;

      await registerClient({
        phone,
        selfie_url: uploadedFileKeys.selfie,
        document_url: uploadedFileKeys.document,
        address_url: uploadedFileKeys.address,
        passport_type: 'ru',
      });

      // Переходим на экран ожидания — send-code будет вызван
      // только после того, как KYC проверка вернёт kycReviewStatus: "approved"
      setStep(2);
    } catch (err) {
      setError(err.message || 'Ошибка регистрации');
    } finally {
      setIsLoading(false);
    }
  };

  // WebSocket для ожидания KYC на шаге 2
  useEffect(() => {
    if (step !== 2) return;

    const phone = '+7' + phoneInput;
    const wsUrl = apiUrl.replace(/^https?:\/\//, 'wss://') + `/ws/user/${userId}`;
    let active = true; // флаг — пользователь ещё на шаге 2

    const disconnect = () => {
      clearInterval(pingRef.current);
      pingRef.current = null;
      if (wsRef.current) {
        wsRef.current.close();
        wsRef.current = null;
      }
    };

    const connect = () => {
      if (!active) return;

      const ws = new WebSocket(wsUrl);
      wsRef.current = ws;

      ws.onopen = () => {
        pingRef.current = setInterval(() => {
          if (ws.readyState === WebSocket.OPEN) ws.send('ping');
        }, 30000);
      };

      ws.onmessage = async (event) => {
        if (event.data === 'pong') return;

        let msg;
        try { msg = JSON.parse(event.data); } catch { return; }

        if (msg.type === 'kyc_status') {
          switch (msg.kycReviewStatus) {
            case 'pending_review':
              // Остаёмся на экране ожидания
              break;

            case 'approved':
              disconnect();
              try {
                const codeResult = await sendVerificationCode(phone);
                if (codeResult.success) {
                  setSendAs(codeResult.sendAs);
                  setStep(3);
                  if (tg) {
                    tg.showAlert(`Код отправлен ${codeResult.sendAs === 'telegram' ? 'в Telegram' : 'по SMS'}`);
                  }
                }
              } catch (err) {
                setError(err.message || 'Ошибка отправки кода');
                setStep(1);
              }
              break;

            case 'rejected':
              disconnect();
              setRejectedReason(msg.rejectedReason || 'Документы не приняты');
              break;

            default:
              break;
          }
        }
      };

      ws.onclose = () => {
        clearInterval(pingRef.current);
        pingRef.current = null;
        // Переподключение через 5 сек, если пользователь ещё на шаге 2
        if (active) {
          setTimeout(connect, 5000);
        }
      };

      ws.onerror = () => ws.close();
    };

    connect();

    return () => {
      active = false;
      disconnect();
    };
  }, [step]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleConfirmVerification = async () => {
    if (verificationCode.length < 4) {
      setError('Введите корректный код');
      return;
    }

    setIsLoading(true);
    setError('');
    track('kyc_passport_type_selected', { type: 'ru' });
    
    try {
      const phone = '+7' + phoneInput;
      
      const result = await confirmVerification({
        phone,
        verification_code: verificationCode,
        selfie_url: uploadedFileKeys.selfie,
        document_url: uploadedFileKeys.document,
        address_url: uploadedFileKeys.address,
        passport_type: 'ru',
      });
      
      if (result.success) {
        setUserPhone(phone);
        localStorage.setItem('userPhone', phone);
        await checkVerificationStatus(phone);
        
        // Показываем экран ожидания результатов
        setStep(4);
      }
    } catch (err) {
      setError(err.message || 'Ошибка подтверждения');
    } finally {
      setIsLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <>
    {showCamera && (
      <PassportCamera
        pageNumber={cameraPage}
        onCapture={handleCameraCapture}
        onClose={() => setShowCamera(false)}
        tg={tg}
      />
    )}
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div 
        className="absolute inset-0 bg-black/80 backdrop-blur-sm"
        onClick={onClose}
      />
      
      <div className="relative w-full h-full overflow-y-auto bg-gradient-to-b from-gray-900 via-gray-900 to-black">
        <div className="min-h-full flex flex-col">
        <div
          className="max-w-md mx-auto w-full px-4 pt-4 mt-auto"
          style={{ paddingBottom: 'calc(env(safe-area-inset-bottom, 0px) + 7rem)' }}
        >

          {/* Header Card */}
          <div className={`rounded-xl p-3 mb-2.5 border ${
            step === 4 
              ? 'bg-emerald-500/10 border-emerald-500/30' 
              : 'bg-gray-800/50 border-gray-700/50'
          }`}>
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className={`rounded-lg p-2 ${
                  step === 4 ? 'bg-emerald-500/20' : 'bg-purple-500/20'
                }`}>
                  {step === 4 ? (
                    <CheckCircle className="w-5 h-5 text-emerald-400" />
                  ) : (
                    <Shield className="w-5 h-5 text-purple-400" />
                  )}
                </div>
                <div>
                  <h1 className="text-base font-bold text-white">
                    {step === 4 ? 'Заявка отправлена' : 'KYC Верификация'}
                  </h1>
                  <p className={`text-xs ${step === 4 ? 'text-emerald-400' : 'text-gray-500'}`}>
                    {step === 4 ? 'Ожидание проверки' : `Шаг ${step} из 3`}
                  </p>
                </div>
              </div>
              <button
                onClick={onClose}
                className="bg-gray-700/50 rounded-lg p-2 hover:bg-gray-700 transition-colors border border-gray-600"
              >
                <X className="w-5 h-5 text-gray-400" />
              </button>
            </div>
          </div>

          {/* Progress Bar - hide on success screen */}
          {step < 4 && (
            <div className="bg-gray-800/50 rounded-xl p-3 mb-2.5 border border-gray-700/50">
              <div className="flex gap-2">
                {[1, 2, 3].map((s) => (
                  <div key={s} className="flex-1">
                    <div className={`h-1.5 rounded-full transition-all ${
                      s < step ? 'bg-green-500' : s === step ? 'bg-purple-500' : 'bg-gray-700'
                    }`} />
                    <p className={`text-xs mt-1 text-center ${
                      s <= step ? 'text-gray-300' : 'text-gray-600'
                    }`}>
                      {s === 1 ? 'Данные' : s === 2 ? 'Проверка' : 'Код'}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Night Time Warning */}
          {isNightTime && <NightTimeWarning />}

          {/* Error Message */}
          {error && (
            <div className="bg-red-500/10 rounded-xl p-3 mb-2.5 border border-red-500/30 flex items-center gap-3">
              <AlertTriangle className="w-5 h-5 text-red-400 flex-shrink-0" />
              <p className="text-sm text-red-300">{error}</p>
            </div>
          )}

          {/* Step 1: Phone + Documents */}
          {step === 1 && (
            <div className="space-y-2.5">
              {/* Phone Input */}
              <div className="bg-gray-800/50 rounded-xl p-3 border border-gray-700/50">
                <div className="flex items-center gap-2.5 mb-2">
                  <div className="bg-green-500/20 rounded-lg p-1.5">
                    <Phone className="w-3.5 h-3.5 text-green-400" />
                  </div>
                  <h3 className="font-semibold text-white text-sm">Номер телефона</h3>
                </div>
                <div className="flex items-center gap-2">
                  <div className="bg-gray-900/80 rounded-lg px-3 py-2 border border-gray-700 text-gray-300 font-semibold text-center min-w-[44px] text-sm">
                    +7
                  </div>
                  <input
                    type="tel"
                    value={phoneInput}
                    onChange={(e) => setPhoneInput(e.target.value.replace(/\D/g, '').slice(0, 10))}
                    placeholder="9XX XXX XX XX"
                    className="flex-1 bg-gray-900/80 rounded-lg px-3 py-2 border border-gray-700 text-white text-sm placeholder-gray-600 focus:border-purple-500 focus:ring-1 focus:ring-purple-500/50 focus:outline-none transition-all"
                    maxLength={10}
                  />
                </div>
                {phoneInput.length === 10 && (
                  <div className="flex items-center gap-2 mt-2 text-green-400">
                    <CheckCircle className="w-3.5 h-3.5" />
                    <span className="text-xs">Номер введён корректно</span>
                  </div>
                )}
              </div>

              {/* Passport Photos */}
              <div className="bg-gray-800/50 rounded-xl p-3 border border-gray-700/50">
                <div className="flex items-center gap-2.5 mb-2">
                  <div className="bg-blue-500/20 rounded-lg p-1.5">
                    <FileText className="w-3.5 h-3.5 text-blue-400" />
                  </div>
                  <h3 className="font-semibold text-white text-sm">Фото паспорта <span className="text-gray-500 font-normal">(2 разворота)</span></h3>
                </div>

                {/* Требования к фото */}
                <div className="bg-teal-500/10 rounded-lg p-2 mb-2.5 border border-teal-500/30">
                  <div className="flex items-start gap-2">
                    <AlertTriangle className="w-3.5 h-3.5 text-teal-400 mt-0.5 flex-shrink-0" />
                    <div>
                      <p className="text-xs font-medium text-teal-400 mb-1">Не принимаются:</p>
                      <div className="text-xs text-teal-300/80 leading-relaxed">
                        Сканы документов, фото с экрана телефона или монитора, просроченные документы, фото с закрытыми серией/номером паспорта
                      </div>
                    </div>
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-2 mb-2.5">
                  {[0, 1].map((index) => (
                    <div key={index} className="relative">
                      {passportPhotos[index] ? (
                        <div className="relative aspect-[4/3] rounded-xl overflow-hidden border-2 border-green-500/50 bg-gray-900">
                          <img
                            src={passportPhotos[index].preview}
                            alt={`Паспорт ${index + 1}`}
                            className="w-full h-full object-cover"
                          />
                          <button
                            onClick={() => removePassportPhoto(index)}
                            className="absolute top-2 right-2 bg-red-500 rounded-lg p-1.5 shadow-lg hover:bg-red-600 transition-colors"
                          >
                            <X className="w-3.5 h-3.5 text-white" />
                          </button>
                          <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-2">
                            <div className="flex items-center gap-1.5">
                              <CheckCircle className="w-3.5 h-3.5 text-green-400" />
                              <span className="text-xs text-white font-medium">Фото {index + 1}</span>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <button
                          onClick={() => openCamera(index + 1)}
                          disabled={isLoading}
                          className="w-full aspect-[4/3] rounded-lg border-2 border-dashed border-gray-600 hover:border-blue-500 hover:bg-blue-500/5 transition-all flex flex-col items-center justify-center gap-1.5 bg-gray-900/50 group"
                        >
                          <div className="w-8 h-8 rounded-full bg-gray-700/50 flex items-center justify-center group-hover:bg-blue-500/20 transition-colors">
                            <Camera className="w-4 h-4 text-gray-500 group-hover:text-blue-400" />
                          </div>
                          <span className="text-xs text-gray-500 group-hover:text-blue-400">
                            {index === 0 ? 'Главный разворот' : 'Прописка'}
                          </span>
                        </button>
                      )}
                    </div>
                  ))}
                </div>

                <input
                  ref={passportInputRef}
                  type="file"
                  accept="image/*"
                  onChange={handlePassportUpload}
                  className="hidden"
                />

                {passportPhotos.length < 2 && (
                  <button
                    onClick={() => openCamera(passportPhotos.length + 1)}
                    disabled={isLoading}
                    className="w-full py-2 rounded-lg bg-blue-600 hover:bg-blue-500 disabled:bg-gray-700 disabled:cursor-not-allowed text-white text-xs font-medium transition-all flex items-center justify-center gap-2"
                  >
                    {isLoading ? (
                      <Loader2 className="w-4 h-4 animate-spin" />
                    ) : (
                      <>
                        <Camera className="w-4 h-4" />
                        Сфотографировать
                      </>
                    )}
                  </button>
                )}

                {passportPhotos.length === 2 && (
                  <div className="flex items-center justify-center gap-2 py-1 text-green-400">
                    <CheckCircle className="w-3.5 h-3.5" />
                    <span className="text-xs font-medium">Все фото загружены</span>
                  </div>
                )}
              </div>

              {/* Selfie */}
              <div className="bg-gray-800/50 rounded-xl p-3 border border-gray-700/50">
                <div className="flex items-center gap-2.5 mb-2">
                  <div className="bg-blue-500/20 rounded-lg p-1.5">
                    <Camera className="w-3.5 h-3.5 text-blue-400" />
                  </div>
                  <h3 className="font-semibold text-white text-sm">Селфи <span className="text-gray-500 font-normal">— фото лица</span></h3>
                </div>

                {selfiePhoto ? (
                  <div className="flex justify-center mb-2">
                    <div className="relative w-20 h-20 rounded-xl overflow-hidden border-2 border-green-500/50 bg-gray-900">
                      <img 
                        src={selfiePhoto.preview} 
                        alt="Селфи"
                        className="w-full h-full object-cover"
                      />
                      <button
                        onClick={() => setSelfiePhoto(null)}
                        className="absolute top-2 right-2 bg-red-500 rounded-lg p-1.5 shadow-lg hover:bg-red-600 transition-colors"
                      >
                        <X className="w-3.5 h-3.5 text-white" />
                      </button>
                      <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-2">
                        <div className="flex items-center justify-center gap-1.5">
                          <CheckCircle className="w-3.5 h-3.5 text-green-400" />
                          <span className="text-xs text-white font-medium">Загружено</span>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <button
                    onClick={() => selfieInputRef.current?.click()}
                    disabled={isLoading}
                    className="w-full py-2 rounded-lg bg-blue-600 hover:bg-blue-500 disabled:bg-gray-700 disabled:cursor-not-allowed text-white text-xs font-medium transition-all flex items-center justify-center gap-2"
                  >
                    {isLoading ? (
                      <Loader2 className="w-4 h-4 animate-spin" />
                    ) : (
                      <>
                        <Camera className="w-4 h-4" />
                        Сделать селфи
                      </>
                    )}
                  </button>
                )}

                <input
                  ref={selfieInputRef}
                  type="file"
                  accept="image/*"
                  capture="user"
                  onChange={handleSelfieUpload}
                  className="hidden"
                />
              </div>

              {/* Why KYC - Expandable */}
              <div className="bg-gray-800/50 rounded-xl border border-gray-700/50 overflow-hidden">
                <button
                  onClick={() => setIsKycInfoOpen(!isKycInfoOpen)}
                  className="w-full flex items-center justify-between p-3"
                >
                  <div className="flex items-center gap-2.5">
                    <div className="bg-purple-500/20 rounded-lg p-1.5">
                      <HelpCircle className="w-3.5 h-3.5 text-purple-400" />
                    </div>
                    <h3 className="font-semibold text-white text-sm">Зачем мне проходить KYC?</h3>
                  </div>
                  <ChevronDown
                    className={`w-5 h-5 text-gray-500 transition-transform duration-200 ${isKycInfoOpen ? 'rotate-180' : ''}`}
                  />
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${isKycInfoOpen ? 'max-h-[600px] pb-5' : 'max-h-0'}`}
                >
                  <div className="px-5 space-y-4">
                    <p className="text-gray-300 text-sm leading-relaxed">
                      <span className="text-white font-semibold">Kit8 Exchange</span> работает официально. Мы провели уже более <span className="text-white font-semibold">1000 безопасных сделок</span> для <span className="text-white font-semibold">500+ постоянных клиентов</span>, и наша главная задача — ваша финансовая безопасность.
                    </p>
                    <p className="text-gray-300 text-sm leading-relaxed">
                      <span className="text-white font-semibold">Защита от блокировок:</span> Верификация позволяет нам проводить платежи через СБП официально. Это исключает риск блокировки вашей карты по <span className="text-white font-semibold">115-ФЗ</span>, который часто возникает при обычных P2P-переводах.
                    </p>
                    <p className="text-gray-300 text-sm leading-relaxed">
                      <span className="text-white font-semibold">Скорость:</span> Благодаря верификации появляется возможность проведения сделок автоматизировано, а значит юани поступают на ваш счёт значительно быстрее, чем в других сервисах.
                    </p>
                    <p className="text-gray-300 text-sm leading-relaxed">
                      <span className="text-white font-semibold">Безопасность данных:</span> Информация зашифрована и используется только для подтверждения личности. Мы не храним и не передаём ваши документы третьим лицам.
                    </p>
                    <p className="text-gray-400 text-sm leading-relaxed font-medium">
                      <span className="text-white font-semibold">Итог:</span> Проходя верификацию, вы получаете доступ к по-настоящему безопасным и быстрым переводам в любое время, не рискуя блокировкой своего счёта по ФЗ-115.
                    </p>
                  </div>
                </div>
              </div>

              {/* Submit Button */}
              <button
                onClick={handleRegisterAndSendCode}
                disabled={isLoading || phoneInput.length !== 10 || passportPhotos.length < 2 || !selfiePhoto}
                className="w-full py-3 rounded-xl bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-500 hover:to-pink-500 disabled:from-gray-700 disabled:to-gray-700 disabled:cursor-not-allowed text-white font-bold text-sm flex items-center justify-center gap-2 transition-all shadow-lg shadow-purple-500/20 disabled:shadow-none"
              >
                {isLoading ? (
                  <>
                    <Loader2 className="w-5 h-5 animate-spin" />
                    <span>Регистрация...</span>
                  </>
                ) : (
                  <>
                    <span>Продолжить</span>
                    <ChevronRight className="w-5 h-5" />
                  </>
                )}
              </button>

              <p className="text-center text-xs text-gray-500">
                После нажатия будет отправлен код подтверждения
              </p>
            </div>
          )}

          {/* Step 2: Waiting for KYC approval / Rejected */}
          {step === 2 && !rejectedReason && (
            <div className="bg-gray-800/50 rounded-xl p-5 border border-gray-700/50 text-center">
              <div className="w-14 h-14 rounded-full bg-purple-500/20 flex items-center justify-center mx-auto mb-3">
                <Loader2 className="w-7 h-7 text-purple-400 animate-spin" />
              </div>
              <h3 className="text-lg font-bold text-white mb-2">Проверка документов...</h3>
              <p className="text-gray-400 text-sm mb-2">Ожидаем подтверждения KYC от системы</p>
              <p className="text-xs text-gray-500">Это может занять несколько минут. Не закрывайте экран.</p>
            </div>
          )}

          {step === 2 && rejectedReason && (
            <div className="space-y-3">
              <div className="bg-amber-500/10 rounded-xl p-5 border border-amber-500/30 text-center">
                <div className="w-14 h-14 rounded-full bg-amber-500/20 flex items-center justify-center mx-auto mb-3">
                  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" viewBox="0 0 256 256" className="text-amber-400"><path d="M88,104H40a8,8,0,0,1-8-8V48a8,8,0,0,1,13.66-5.66L64,60.7a95.42,95.42,0,0,1,66-26.76h.53a95.36,95.36,0,0,1,67.07,27.33,8,8,0,0,1-11.18,11.44,79.52,79.52,0,0,0-55.89-22.77h-.45A79.48,79.48,0,0,0,75.35,72L93.66,90.34A8,8,0,0,1,88,104Zm128,48H168a8,8,0,0,0-5.66,13.66L180.65,184a79.48,79.48,0,0,1-54.72,22.09h-.45a79.52,79.52,0,0,1-55.89-22.77,8,8,0,1,0-11.18,11.44,95.36,95.36,0,0,0,67.07,27.33H126a95.42,95.42,0,0,0,66-26.76l18.36,18.36A8,8,0,0,0,224,208V160A8,8,0,0,0,216,152Z"></path></svg>
                </div>
                <h3 className="text-lg font-bold text-white mb-2">Документы отклонены</h3>
                <p className="text-gray-400 text-sm">{rejectedReason}</p>
              </div>
              <button
                onClick={() => { setRejectedReason(null); setStep(1); setError(''); setPassportPhotos([]); setSelfiePhoto(null); setUploadedFileKeys({ selfie: null, document: null, address: null }); }}
                className="w-full py-3.5 rounded-xl bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-500 hover:to-indigo-500 text-white font-bold transition-all"
              >
                Подать заново
              </button>
            </div>
          )}

          {/* Step 3: Enter Code */}
          {step === 3 && (
            <div className="space-y-3">
              {/* Code Input Card */}
              <div className="bg-gray-800/50 rounded-xl p-3 border border-gray-700/50">
                <div className="flex items-center gap-3 mb-3">
                  <div className="bg-green-500/20 rounded-lg p-1.5">
                    <Shield className="w-4 h-4 text-green-400" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-white">Код подтверждения</h3>
                    <p className="text-xs text-gray-500">
                      Отправлен {sendAs === 'telegram' ? 'в Telegram' : 'по SMS'}
                    </p>
                  </div>
                </div>
                
                <div className="bg-gray-900/50 rounded-xl p-3 mb-3 border border-gray-700/30">
                  <p className="text-sm text-gray-400 text-center">
                    Номер: <span className="text-white font-medium">+7 {phoneInput}</span>
                  </p>
                </div>
                
                {/* Code Input Field - Professional Design */}
                <div className="mb-3">
                  <div className="relative">
                    <input
                      type="text"
                      value={verificationCode}
                      onChange={(e) => setVerificationCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
                      placeholder="• • • • • •"
                      className="w-full bg-gray-900/80 rounded-xl px-6 py-4 border-2 border-gray-700 text-white text-center text-2xl tracking-[0.4em] font-mono placeholder-gray-600 focus:border-green-500 focus:ring-2 focus:ring-green-500/30 focus:outline-none transition-all"
                      maxLength={6}
                      autoFocus
                    />
                    {verificationCode.length === 6 && (
                      <div className="absolute right-4 top-1/2 -translate-y-1/2">
                        <CheckCircle className="w-6 h-6 text-green-400" />
                      </div>
                    )}
                  </div>
                  <p className="text-center text-xs text-gray-500 mt-2">
                    Введите {6 - verificationCode.length} {verificationCode.length === 5 ? 'цифру' : 'цифр'}
                  </p>
                </div>
              </div>

              {/* Confirm Button */}
              <button
                onClick={handleConfirmVerification}
                disabled={isLoading || verificationCode.length < 4}
                className="w-full py-3.5 rounded-xl bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-500 hover:to-emerald-500 disabled:from-gray-700 disabled:to-gray-700 disabled:cursor-not-allowed text-white font-bold flex items-center justify-center gap-2 transition-all shadow-lg shadow-green-500/20 disabled:shadow-none"
              >
                {isLoading ? (
                  <>
                    <Loader2 className="w-5 h-5 animate-spin" />
                    <span>Проверка...</span>
                  </>
                ) : (
                  <>
                    <CheckCircle className="w-5 h-5" />
                    <span>Подтвердить</span>
                  </>
                )}
              </button>

              {/* Back Button */}
              <button
                onClick={() => setStep(1)}
                className="w-full py-3.5 rounded-xl bg-gray-800/50 border border-gray-700/50 hover:bg-gray-700/50 text-gray-300 font-medium transition-all"
              >
                Назад
              </button>
              
              <p className="text-center text-xs text-gray-500">
                Не получили код? Вернитесь назад и попробуйте снова
              </p>
            </div>
          )}

          {/* Step 4: Success - Pending Verification */}
          {step === 4 && (
            <div className="space-y-3">
              {/* Success Card */}
              <div className="bg-gradient-to-br from-emerald-500/10 via-green-500/5 to-teal-500/10 rounded-xl p-5 border border-emerald-500/20 text-center">
                {/* Animated Check Icon */}
                <div className="relative mx-auto w-18 h-18 mb-4">
                  <div className="absolute inset-0 bg-emerald-500/20 rounded-full animate-ping" />
                  <div className="absolute inset-2 bg-emerald-500/30 rounded-full animate-pulse" />
                  <div className="relative w-full h-full bg-gradient-to-br from-emerald-500 to-green-600 rounded-full flex items-center justify-center shadow-lg shadow-emerald-500/30">
                    <CheckCircle className="w-12 h-12 text-white" />
                  </div>
                </div>

                <h2 className="text-xl font-bold text-white mb-2">
                  Заявка отправлена
                </h2>

                <p className="text-gray-300 text-base mb-1.5">
                  Ожидайте результатов проверки личности
                </p>
                
                <p className="text-gray-500 text-sm">
                  Обычно проверка занимает от нескольких минут до 10 минут
                </p>
              </div>

              {/* Info Card */}
              <div className="bg-gray-800/50 rounded-xl p-3 border border-gray-700/50">
                <div className="flex items-start gap-3">
                  <div className="bg-blue-500/20 rounded-lg p-2 flex-shrink-0">
                    <Clock className="w-5 h-5 text-blue-400" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-white mb-1">Что дальше?</h3>
                    <p className="text-gray-400 text-sm leading-relaxed">
                      Мы уведомим вас о результате проверки. После успешной верификации вам станут доступны все функции сервиса.
                    </p>
                  </div>
                </div>
              </div>

              {/* Status Indicators */}
              <div className="bg-gray-800/50 rounded-xl p-3 border border-gray-700/50">
                <div className="space-y-2.5">
                  <div className="flex items-center gap-3">
                    <div className="w-2 h-2 rounded-full bg-emerald-500" />
                    <span className="text-gray-300 text-sm">Документы загружены</span>
                    <CheckCircle className="w-4 h-4 text-emerald-500 ml-auto" />
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-2 h-2 rounded-full bg-emerald-500" />
                    <span className="text-gray-300 text-sm">Код подтверждён</span>
                    <CheckCircle className="w-4 h-4 text-emerald-500 ml-auto" />
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-2 h-2 rounded-full bg-yellow-500 animate-pulse" />
                    <span className="text-gray-300 text-sm">Проверка личности</span>
                    <Loader2 className="w-4 h-4 text-yellow-500 ml-auto animate-spin" />
                  </div>
                </div>
              </div>

              {/* Close Button */}
              <button
                onClick={onClose}
                className="w-full py-3.5 rounded-xl bg-gradient-to-r from-emerald-600 to-green-600 hover:from-emerald-500 hover:to-green-500 text-white font-semibold transition-all shadow-lg shadow-emerald-500/20 flex items-center justify-center gap-2"
              >
                <span>Понятно</span>
              </button>
            </div>
          )}
        </div>
        </div>
      </div>
    </div>
    </>
  );
};

const ProfileScreen = ({
  profileTab, 
  setProfileTab,
  requests,
  history,
  stats,
  loadUserData,
  tg,
  setOrderDetails,
  setCurrentScreen,
  userFirstName,
  userLastName,
  telegramUsername,
  userPhotoUrl,
  paymentLimits,
  // Altyn KYC props
  verificationStatus,
  userPhone,
  setUserPhone,
  uploadDocument,
  registerClient,
  sendVerificationCode,
  confirmVerification,
  checkVerificationStatus,
  // Section navigation (from App.js)
  activeSection,
  setActiveSection,
  // API
  apiUrl,
  makeAuthenticatedRequest,
  userId,
}) => {
  const [isKYCModalOpen, setIsKYCModalOpen] = useState(false);
  
  // Referral data
  const [referralData, setReferralData] = useState(null);
  const [referralLoading, setReferralLoading] = useState(false);
  const [referralCopied, setReferralCopied] = useState(false);

  // Track KYC page open
  useEffect(() => {
    if (activeSection === 'kyc') {
      track('page_kyc');
    }
  }, [activeSection]);

  // Load referral data when entering referral section
  useEffect(() => {
    const loadReferralData = async () => {
      if (activeSection === 'referral' && !referralData && makeAuthenticatedRequest && apiUrl) {
        setReferralLoading(true);
        try {
          const response = await makeAuthenticatedRequest(`${apiUrl}/api/user/referral`);
          
          if (response.ok) {
            const data = await response.json();
            if (data.success) {
              setReferralData(data);
            }
          }
        } catch (error) {
          console.error('Failed to load referral data:', error);
        } finally {
          setReferralLoading(false);
        }
      }
    };
    loadReferralData();
  }, [activeSection, referralData, makeAuthenticatedRequest, apiUrl]);

  // Copy referral link to clipboard
  const copyReferralLink = async () => {
    if (referralData?.referralLink) {
      try {
        await navigator.clipboard.writeText(referralData.referralLink);
        setReferralCopied(true);
        if (tg?.HapticFeedback) {
          tg.HapticFeedback.notificationOccurred('success');
        }
        setTimeout(() => setReferralCopied(false), 2000);
      } catch (error) {
        // Fallback for older browsers
        const textArea = document.createElement('textarea');
        textArea.value = referralData.referralLink;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
        setReferralCopied(true);
        setTimeout(() => setReferralCopied(false), 2000);
      }
    }
  };

  const isAdmin = verificationStatus?.isAdmin || false;
  const isVerified = verificationStatus?.isVerified || isAdmin || false;
  const isVerificationLoading = verificationStatus?.isLoading || false;
  const passportState = verificationStatus?.passportState || 'not_registered';

  // Poll verification status while processing
  useEffect(() => {
    if (passportState !== 'processing' || !userPhone) return;
    const interval = setInterval(() => {
      checkVerificationStatus(userPhone);
    }, 10000);
    return () => clearInterval(interval);
  }, [passportState, userPhone, checkVerificationStatus]);

  // Лимиты из API
  const sbpLimits = paymentLimits?.sbp || {
    perTransaction: 100000,
    daily: { limit: 100000, used: 0, remaining: 100000, percent: 0 },
    monthly: { limit: 500000, used: 0, remaining: 500000, percent: 0 },
  };
  const vtbLimits = paymentLimits?.vtb || {
    perTransaction: 300000,
    daily: { limit: 1000000, used: 0, remaining: 1000000, percent: 0 },
    monthly: { limit: 1000000, used: 0, remaining: 1000000, percent: 0 },
  };

  // Get status text and color
  const getVerificationStatusDisplay = () => {
    if (isVerificationLoading) {
      return { text: 'Проверка...', color: 'text-gray-400', bg: 'bg-gray-700/50' };
    }
    if (isAdmin) {
      return { text: 'Администратор', color: 'text-purple-400', bg: 'bg-purple-900/30 border-purple-700/50' };
    }
    if (isVerified) {
      return { text: 'Верифицирован', color: 'text-green-400', bg: 'bg-green-900/30 border-green-700/50' };
    }
    if (passportState === 'processing') {
      return { text: 'На проверке', color: 'text-yellow-400', bg: 'bg-yellow-900/30 border-yellow-700/50' };
    }
    if (passportState === 'failed') {
      return { text: 'Отклонено', color: 'text-amber-400', bg: 'bg-amber-900/30 border-amber-700/50' };
    }
    return { text: 'Не пройдена', color: 'text-gray-400', bg: 'bg-gray-700/50' };
  };

  const statusDisplay = getVerificationStatusDisplay();

  // Navigation menu items
  const menuItems = [
    { id: 'limits', label: 'Мои лимиты', icon: LimitsIcon, fillColor: '#4ade80', bg: 'bg-green-500/20' },
    { id: 'requests', label: 'Мои заявки', icon: ZayavkiIcon, fillColor: '#60a5fa', bg: 'bg-blue-500/20' },
    { id: 'kyc', label: 'Верификация (KYC)', icon: VerificationIcon, fillColor: '#fbbf24', bg: 'bg-amber-500/20' },
    { id: 'referral', label: 'Реферальная система', icon: Users, fillColor: null, color: 'text-purple-400', bg: 'bg-purple-500/20' },
    { id: 'stats', label: 'Статистика', icon: StatsIcon, fillColor: '#22d3ee', bg: 'bg-cyan-500/20' },
  ];

  // Section header with back button
  const SectionHeader = ({ title }) => (
    <button 
      onClick={() => setActiveSection(null)}
      className="flex items-center gap-3 mb-4 group"
    >
      <div className="bg-gray-700/50 rounded-xl p-2 group-hover:bg-gray-600/50 transition-colors">
        <ArrowLeft className="w-5 h-5 text-gray-400 group-hover:text-white" />
      </div>
      <h2 className="text-lg font-bold text-white">{title}</h2>
    </button>
  );

  return (
  <div className="min-h-screen bg-gradient-to-b from-gray-900 via-gray-900 to-black p-4">
    <div className="max-w-md mx-auto pt-20">
      
      {/* User Card - Always visible */}
      <div className="bg-gray-800/50 rounded-2xl p-5 mb-4 border border-gray-700/50">
        <div className="flex items-center gap-4">
          <div className="relative">
            {userPhotoUrl ? (
              <img 
                src={userPhotoUrl} 
                alt="Profile" 
                className="w-16 h-16 rounded-full border-2 border-purple-500/30 object-cover"
              />
            ) : (
              <div className="w-16 h-16 rounded-full bg-purple-500/20 flex items-center justify-center border-2 border-purple-500/30">
                <User className="w-8 h-8 text-purple-400" />
              </div>
            )}
            {/* Verification Badge */}
            {isVerified && (
              <div className="absolute -bottom-1 -right-1 bg-green-500 rounded-full p-1 border-2 border-gray-900">
                <VerifiedCheckIcon className="w-3 h-3" style={{ fill: 'white' }} />
              </div>
            )}
          </div>
          <div className="flex-1">
            <h2 className="text-xl font-bold text-white">
              {userFirstName || 'Личный кабинет'}
            </h2>
            {telegramUsername && (
              <p className="text-purple-400 text-sm">@{telegramUsername}</p>
            )}
            {/* Verification Status Badge */}
            <div className={`inline-flex items-center gap-1.5 px-2.5 py-1 mt-2 rounded-lg ${statusDisplay.bg} border text-xs`}>
              {passportState === 'failed' ? (
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 256 256" className={statusDisplay.color}><path d="M88,104H40a8,8,0,0,1-8-8V48a8,8,0,0,1,13.66-5.66L64,60.7a95.42,95.42,0,0,1,66-26.76h.53a95.36,95.36,0,0,1,67.07,27.33,8,8,0,0,1-11.18,11.44,79.52,79.52,0,0,0-55.89-22.77h-.45A79.48,79.48,0,0,0,75.35,72L93.66,90.34A8,8,0,0,1,88,104Zm128,48H168a8,8,0,0,0-5.66,13.66L180.65,184a79.48,79.48,0,0,1-54.72,22.09h-.45a79.52,79.52,0,0,1-55.89-22.77,8,8,0,1,0-11.18,11.44,95.36,95.36,0,0,0,67.07,27.33H126a95.42,95.42,0,0,0,66-26.76l18.36,18.36A8,8,0,0,0,224,208V160A8,8,0,0,0,216,152Z"></path></svg>
              ) : (
                <Shield className={`w-3.5 h-3.5 ${statusDisplay.color}`} />
              )}
              <span className={`font-medium ${statusDisplay.color}`}>{statusDisplay.text}</span>
            </div>
          </div>
        </div>
      </div>

      {/* Main Navigation Menu */}
      {activeSection === null && (
        <>
          {/* Processing KYC Info */}
          {passportState === 'processing' && (
            <div className="mb-4 bg-yellow-900/20 rounded-2xl p-4 border border-yellow-700/50">
              <div className="flex items-center gap-3">
                <div className="bg-yellow-500/20 rounded-xl p-2.5">
                  <Clock className="w-5 h-5 text-yellow-400" />
                </div>
                <div>
                  <p className="font-semibold text-yellow-300">Верификация на проверке</p>
                  <p className="text-xs text-gray-500">Обычно занимает до 10 минут</p>
                </div>
              </div>
            </div>
          )}

          {/* Navigation Buttons */}
          <div className="space-y-2 mb-4">
            {menuItems.map((item) => (
              <button
                key={item.id}
                onClick={() => {
                  if (item.id === 'kyc' && !isVerified && passportState !== 'processing') {
                    setIsKYCModalOpen(true);
                  } else {
                    setActiveSection(item.id);
                  }
                }}
                className="w-full bg-gray-800/50 rounded-2xl p-4 flex items-center justify-between border border-gray-700/50 hover:border-gray-600 hover:bg-gray-800 transition-all group"
              >
                <div className="flex items-center gap-4">
                  <div className={`${item.bg} rounded-xl p-2.5`}>
                    {item.fillColor ? (
                      <item.icon className="w-5 h-5" style={{ fill: item.fillColor }} />
                    ) : (
                      <item.icon className={`w-5 h-5 ${item.color}`} />
                    )}
                  </div>
                  <span className="font-medium text-white group-hover:text-gray-100">{item.label}</span>
                </div>
                <ChevronRight className="w-5 h-5 text-gray-500 group-hover:text-gray-400 group-hover:translate-x-1 transition-all" />
              </button>
            ))}
          </div>
        </>
      )}

      {/* Limits Section */}
      {activeSection === 'limits' && (
        <>
          <SectionHeader title="Мои лимиты" />
          <div className="bg-gray-800/50 rounded-2xl p-4 border border-gray-700/50 mb-4">
            <div className="space-y-4">
              {/* СБП */}
              <div>
                <div className="flex items-center gap-2 mb-3">
                  <SBPIcon className="w-6 h-7" />
                  <span className="text-sm font-medium text-white">Лимиты СБП</span>
                </div>
                <div className="space-y-2">
                  <div className="flex justify-between items-center">
                    <span className="text-xs text-gray-500">За транзакцию</span>
                    <span className="text-sm font-semibold text-white">{sbpLimits.perTransaction?.toLocaleString()} ₽</span>
                  </div>
                  <div>
                    <div className="flex justify-between items-center mb-1">
                      <span className="text-xs text-gray-500">Дневной лимит</span>
                      <span className="text-xs text-gray-400">{sbpLimits.daily?.used?.toLocaleString()} / {sbpLimits.daily?.limit?.toLocaleString()} ₽</span>
                    </div>
                    <div className="w-full h-2 bg-gray-700 rounded-full overflow-hidden">
                      <div className="h-full bg-gradient-to-r from-green-500 to-emerald-400 rounded-full" style={{ width: `${Math.max(sbpLimits.daily?.percent || 0, 2)}%` }} />
                    </div>
                  </div>
                  <div>
                    <div className="flex justify-between items-center mb-1">
                      <span className="text-xs text-gray-500">Месячный лимит</span>
                      <span className="text-xs text-gray-400">{sbpLimits.monthly?.used?.toLocaleString()} / {sbpLimits.monthly?.limit?.toLocaleString()} ₽</span>
                    </div>
                    <div className="w-full h-2 bg-gray-700 rounded-full overflow-hidden">
                      <div className="h-full bg-gradient-to-r from-green-500 to-emerald-400 rounded-full" style={{ width: `${Math.max(sbpLimits.monthly?.percent || 0, 2)}%` }} />
                    </div>
                  </div>
                </div>
              </div>

              <div className="border-t border-gray-700"></div>

              {/* ВТБ */}
              <div>
                <div className="flex items-center gap-2 mb-3">
                  <VTBIcon className="w-12 h-6" />
                  <span className="text-sm font-medium text-white">Лимиты ВТБ</span>
                </div>
                <div className="space-y-2">
                  <div className="flex justify-between items-center">
                    <span className="text-xs text-gray-500">За транзакцию</span>
                    <span className="text-sm font-semibold text-white">{vtbLimits.perTransaction?.toLocaleString()} ₽</span>
                  </div>
                  <div>
                    <div className="flex justify-between items-center mb-1">
                      <span className="text-xs text-gray-500">Дневной лимит</span>
                      <span className="text-xs text-gray-400">{vtbLimits.daily?.used?.toLocaleString()} / {vtbLimits.daily?.limit?.toLocaleString()} ₽</span>
                    </div>
                    <div className="w-full h-2 bg-gray-700 rounded-full overflow-hidden">
                      <div className="h-full bg-gradient-to-r from-blue-500 to-indigo-400 rounded-full" style={{ width: `${Math.max(vtbLimits.daily?.percent || 0, 2)}%` }} />
                    </div>
                  </div>
                  <div>
                    <div className="flex justify-between items-center mb-1">
                      <span className="text-xs text-gray-500">Месячный лимит</span>
                      <span className="text-xs text-gray-400">{vtbLimits.monthly?.used?.toLocaleString()} / {vtbLimits.monthly?.limit?.toLocaleString()} ₽</span>
                    </div>
                    <div className="w-full h-2 bg-gray-700 rounded-full overflow-hidden">
                      <div className="h-full bg-gradient-to-r from-blue-500 to-indigo-400 rounded-full" style={{ width: `${Math.max(vtbLimits.monthly?.percent || 0, 2)}%` }} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {/* KYC Section */}
      {activeSection === 'kyc' && (
        <>
          <SectionHeader title="Верификация (KYC)" />
          <div className="bg-gray-800/50 rounded-2xl p-5 border border-gray-700/50 mb-4">
            <div className="text-center">
              <div className={`w-16 h-16 mx-auto mb-4 rounded-full flex items-center justify-center ${statusDisplay.bg}`}>
                {passportState === 'failed' ? (
                  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" viewBox="0 0 256 256" className={statusDisplay.color}><path d="M88,104H40a8,8,0,0,1-8-8V48a8,8,0,0,1,13.66-5.66L64,60.7a95.42,95.42,0,0,1,66-26.76h.53a95.36,95.36,0,0,1,67.07,27.33,8,8,0,0,1-11.18,11.44,79.52,79.52,0,0,0-55.89-22.77h-.45A79.48,79.48,0,0,0,75.35,72L93.66,90.34A8,8,0,0,1,88,104Zm128,48H168a8,8,0,0,0-5.66,13.66L180.65,184a79.48,79.48,0,0,1-54.72,22.09h-.45a79.52,79.52,0,0,1-55.89-22.77,8,8,0,1,0-11.18,11.44,95.36,95.36,0,0,0,67.07,27.33H126a95.42,95.42,0,0,0,66-26.76l18.36,18.36A8,8,0,0,0,224,208V160A8,8,0,0,0,216,152Z"></path></svg>
                ) : (
                  <Shield className={`w-8 h-8 ${statusDisplay.color}`} />
                )}
              </div>
              <h3 className={`text-lg font-bold ${statusDisplay.color} mb-2`}>{statusDisplay.text}</h3>
              {isVerified ? (
                <p className="text-gray-400 text-sm">Вы успешно прошли верификацию и можете создавать заявки</p>
              ) : passportState === 'processing' ? (
                <div>
                  <p className="text-gray-400 text-sm mb-3">Ваши документы на проверке. Обычно это занимает до 10 минут.</p>
                  <Loader2 className="w-6 h-6 text-yellow-400 animate-spin mx-auto" />
                </div>
              ) : passportState === 'failed' ? (
                <div className="space-y-4">
                  <p className="text-gray-300 text-sm">Документы не прошли проверку. Пожалуйста, загрузите новые фотографии — убедитесь, что данные чётко видны и нет бликов.</p>
                  <button
                    onClick={() => setIsKYCModalOpen(true)}
                    className="w-full py-4 rounded-2xl bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-500 hover:to-indigo-500 text-white font-bold transition-all"
                  >
                    Подать заново
                  </button>
                </div>
              ) : (
                <>
                  <p className="text-gray-400 text-sm mb-4">Пройдите верификацию для создания заявок</p>
                  <button
                    onClick={() => setIsKYCModalOpen(true)}
                    className="bg-amber-600 hover:bg-amber-500 text-white font-medium py-3 px-6 rounded-xl transition-colors"
                  >
                    Пройти KYC
                  </button>
                </>
              )}
            </div>
          </div>
        </>
      )}

      {/* Referral Section */}
      {activeSection === 'referral' && (
        <>
          <SectionHeader title="Реферальная система" />
          
          {referralLoading ? (
            <div className="bg-gray-800/50 rounded-2xl p-8 border border-gray-700/50 mb-4">
              <div className="flex flex-col items-center justify-center">
                <Loader2 className="w-8 h-8 text-purple-400 animate-spin mb-3" />
                <p className="text-gray-400 text-sm">Загрузка...</p>
              </div>
            </div>
          ) : referralData ? (
            <>
              {/* Referral Link Card */}
              <div className="bg-gradient-to-br from-purple-900/40 to-pink-900/40 rounded-2xl p-5 border border-purple-700/50 mb-4">
                <div className="flex items-center gap-3 mb-4">
                  <div className="bg-purple-500/30 rounded-xl p-2.5">
                    <Gift className="w-6 h-6 text-purple-400" />
                  </div>
                  <div>
                    <h3 className="font-bold text-white">Приглашайте друзей</h3>
                    <p className="text-xs text-purple-300">
                      Ваша ставка: {(referralData.progression?.currentRatePercent ?? referralData.currentRatePercent ?? 0.75)}% с оборота друзей
                    </p>
                  </div>
                </div>
                
                {/* Referral Link */}
                <div className="bg-gray-900/60 rounded-xl p-3 mb-3">
                  <p className="text-xs text-gray-400 mb-1">Ваша реферальная ссылка</p>
                  <p className="text-sm text-white font-medium break-all">{referralData.referralLink}</p>
                </div>
                
                {/* Copy Button */}
                <button
                  onClick={copyReferralLink}
                  className={`w-full py-3 rounded-xl font-medium flex items-center justify-center gap-2 transition-all ${
                    referralCopied 
                      ? 'bg-green-600 text-white' 
                      : 'bg-purple-600 hover:bg-purple-500 text-white'
                  }`}
                >
                  {referralCopied ? (
                    <>
                      <CheckCircle className="w-5 h-5" />
                      Скопировано!
                    </>
                  ) : (
                    <>
                      <Copy className="w-5 h-5" />
                      Скопировать ссылку
                    </>
                  )}
                </button>
              </div>

              {/* Stats Grid */}
              <div className="grid grid-cols-2 gap-3 mb-4">
                <div className="bg-gray-800/50 rounded-2xl p-4 border border-gray-700/50">
                  <div className="flex items-center gap-2 mb-2">
                    <div className="bg-blue-500/20 rounded-lg p-1.5">
                      <Users className="w-4 h-4 text-blue-400" />
                    </div>
                    <span className="text-xs text-gray-400">Приглашено</span>
                  </div>
                  <p className="text-2xl font-bold text-white">{referralData.referralCount || 0}</p>
                  <p className="text-xs text-gray-500">человек</p>
                </div>
                
                <div className="bg-gray-800/50 rounded-2xl p-4 border border-gray-700/50">
                  <div className="flex items-center gap-2 mb-2">
                    <div className="bg-green-500/20 rounded-lg p-1.5">
                      <DollarSign className="w-4 h-4 text-green-400" />
                    </div>
                    <span className="text-xs text-gray-400">Всего заработано</span>
                  </div>
                  <p className="text-2xl font-bold text-green-400">{(referralData.earningsCny?.total ?? 0).toFixed(2)} ¥</p>
                  <p className="text-xs text-gray-500">{(referralData.earnings?.total ?? 0).toFixed(2)} USDT</p>
                </div>
              </div>

              {/* Progression Card */}
              {referralData.progression && (
                <div className="bg-gradient-to-br from-indigo-900/40 to-purple-900/30 rounded-2xl p-5 border border-indigo-700/40 mb-4">
                  {(() => {
                    const p = referralData.progression;
                    const turnover = p.turnoverRub || 0;
                    const tiers = p.tiers || [];
                    const fmt = (n) => Math.round(Math.max(0, n)).toLocaleString('ru-RU');
                    // Индекс текущего уровня = самый высокий тир, чей порог достигнут
                    const currentIdx = tiers.reduce((acc, t, i) => (turnover >= t.fromRub ? i : acc), 0);
                    const next = p.nextThresholdRub;
                    const curFrom = tiers[currentIdx]?.fromRub ?? 0;
                    const span = next != null ? (next - curFrom) : 1;
                    const filled = next != null ? Math.min(100, Math.max(0, ((turnover - curFrom) / span) * 100)) : 100;
                    return (
                      <>
                        {/* Заголовок: текущий уровень */}
                        <div className="flex items-center justify-between mb-3">
                          <div className="flex items-center gap-2">
                            <div className="bg-indigo-500/30 rounded-lg p-1.5">
                              <TrendingUp className="w-4 h-4 text-indigo-300" />
                            </div>
                            <span className="text-sm font-medium text-white">Ваш уровень</span>
                          </div>
                          <span className="text-xs font-bold text-indigo-200 bg-indigo-500/20 px-2.5 py-1 rounded-full">
                            Уровень {currentIdx + 1} · {p.currentRatePercent}%
                          </span>
                        </div>

                        {/* Правило */}
                        <p className="text-xs text-gray-400 mb-4 leading-relaxed">
                          Ставка растёт от суммарного оборота приглашённых друзей. Чем больше они меняют — тем выше ваш %.
                        </p>

                        {/* Оборот + прогресс */}
                        <div className="flex items-baseline justify-between mb-1">
                          <span className="text-xs text-gray-400">Оборот рефералов</span>
                          <span className="text-sm font-bold text-white">{fmt(turnover)} ₽</span>
                        </div>
                        <div className="h-2 bg-gray-700/60 rounded-full overflow-hidden mb-2">
                          <div className="h-full bg-gradient-to-r from-indigo-400 to-purple-400 rounded-full transition-all" style={{ width: `${filled}%` }} />
                        </div>
                        {next != null ? (
                          <p className="text-xs text-gray-300 mb-4">
                            До уровня {currentIdx + 2} ({p.nextRatePercent}%) осталось <span className="text-white font-semibold">{fmt(p.remainingToNextRub)} ₽</span> оборота
                          </p>
                        ) : (
                          <p className="text-xs text-green-400 mb-4">Максимальный уровень достигнут 🎉</p>
                        )}

                        {/* Лесенка уровней */}
                        <div className="space-y-1.5">
                          {tiers.map((t, i) => {
                            const achieved = turnover >= t.fromRub;
                            const isCurrent = i === currentIdx;
                            const remaining = t.fromRub - turnover;
                            return (
                              <div key={i} className={`flex items-center gap-3 px-3 py-2.5 rounded-xl border ${
                                isCurrent ? 'bg-indigo-500/20 border-indigo-500/50'
                                : 'bg-gray-800/40 border-transparent'
                              }`}>
                                <div className={`w-6 h-6 rounded-full flex items-center justify-center shrink-0 ${
                                  isCurrent ? 'bg-indigo-500 text-white'
                                  : achieved ? 'bg-green-500/20 text-green-400'
                                  : 'bg-gray-700 text-gray-500'
                                }`}>
                                  {achieved
                                    ? (isCurrent ? <TrendingUp className="w-3.5 h-3.5" /> : <CheckCircle className="w-3.5 h-3.5" />)
                                    : <Lock className="w-3 h-3" />}
                                </div>
                                <div className="flex-1 min-w-0">
                                  <p className={`text-xs font-medium ${achieved ? 'text-white' : 'text-gray-400'}`}>
                                    Уровень {i + 1} — {t.ratePercent}%
                                  </p>
                                  <p className="text-[11px] text-gray-500">
                                    {isCurrent ? 'Текущий уровень' : achieved ? 'Пройден' : `ещё ${fmt(remaining)} ₽ оборота`}
                                  </p>
                                </div>
                                <span className="text-[11px] text-gray-500 shrink-0">
                                  {t.fromRub > 0 ? `от ${fmt(t.fromRub)} ₽` : 'старт'}
                                </span>
                              </div>
                            );
                          })}
                        </div>
                      </>
                    );
                  })()}
                </div>
              )}

              {/* Earnings Details */}
              <div className="bg-gray-800/50 rounded-2xl p-4 border border-gray-700/50 mb-4">
                <h3 className="text-sm font-medium text-gray-400 mb-4">Детали заработка</h3>
                
                <div className="space-y-3">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 bg-yellow-500/20 rounded-xl flex items-center justify-center">
                        <Clock className="w-5 h-5 text-yellow-400" />
                      </div>
                      <div>
                        <p className="text-sm text-white">Ожидает выплаты</p>
                        <p className="text-xs text-gray-500">{(referralData.earnings?.pending ?? 0).toFixed(2)} USDT</p>
                      </div>
                    </div>
                    <p className="text-lg font-bold text-yellow-400">{(referralData.earningsCny?.pending ?? 0).toFixed(2)} ¥</p>
                  </div>
                  
                  <div className="border-t border-gray-700"></div>
                  
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 bg-green-500/20 rounded-xl flex items-center justify-center">
                        <CheckCircle className="w-5 h-5 text-green-400" />
                      </div>
                      <div>
                        <p className="text-sm text-white">Выплачено</p>
                        <p className="text-xs text-gray-500">{(referralData.earnings?.paid ?? 0).toFixed(2)} USDT</p>
                      </div>
                    </div>
                    <p className="text-lg font-bold text-green-400">{(referralData.earningsCny?.paid ?? 0).toFixed(2)} ¥</p>
                  </div>
                </div>
              </div>

              {/* Withdrawal Terms */}
              <div className="bg-gray-800/50 rounded-2xl p-4 border border-gray-700/50 mb-4">
                <div className="flex items-center gap-2 mb-3">
                  <div className="bg-purple-500/20 rounded-lg p-1.5">
                    <Wallet className="w-4 h-4 text-purple-400" />
                  </div>
                  <h3 className="text-sm font-medium text-white">Вывод средств</h3>
                </div>

                <p className="text-xs text-gray-400 leading-relaxed mb-3">
                  Вывод — по запросу в поддержку, от суммы эквивалентом{' '}
                  <span className="text-white font-medium">15 USDT</span>.
                </p>

                <p className="text-[11px] text-gray-500 mb-2">Способы вывода:</p>
                <div className="space-y-1.5">
                  <div className="flex items-center gap-2.5 bg-gray-900/40 rounded-lg px-3 py-2">
                    <div className="w-7 h-7 rounded-lg bg-green-500/15 flex items-center justify-center shrink-0">
                      <span className="text-[10px] font-bold text-green-400">TRC</span>
                    </div>
                    <span className="text-xs text-white">Криптовалюта на адрес TRC-20</span>
                  </div>

                  <div className="flex items-center gap-2.5 bg-gray-900/40 rounded-lg px-3 py-2">
                    <div className="w-7 h-7 rounded-lg bg-blue-500/15 flex items-center justify-center shrink-0">
                      <Wallet className="w-3.5 h-3.5 text-blue-400" />
                    </div>
                    <span className="text-xs text-white">Перевод на Alipay / WeChat</span>
                  </div>

                  <div className="flex items-center justify-between gap-2.5 bg-gray-900/30 rounded-lg px-3 py-2 opacity-70">
                    <div className="flex items-center gap-2.5 min-w-0">
                      <div className="w-7 h-7 rounded-lg bg-gray-700/40 flex items-center justify-center shrink-0">
                        <CreditCard className="w-3.5 h-3.5 text-gray-500" />
                      </div>
                      <span className="text-xs text-gray-400 truncate">Вывод на карту рублями</span>
                    </div>
                    <span className="text-[10px] font-bold text-yellow-400 bg-yellow-500/15 px-2 py-0.5 rounded-full shrink-0">SOON</span>
                  </div>
                </div>
              </div>

              {/* Info Card */}
              <div className="bg-gray-800/30 rounded-2xl p-4 border border-gray-700/30">
                <div className="flex items-start gap-3">
                  <div className="bg-blue-500/20 rounded-lg p-2 mt-0.5">
                    <HelpCircle className="w-4 h-4 text-blue-400" />
                  </div>
                  <div>
                    <h4 className="text-sm font-medium text-white mb-1">Как это работает?</h4>
                    <p className="text-xs text-gray-400 leading-relaxed">
                      Делитесь ссылкой с друзьями. Когда они совершают обмен, вам начисляется процент от оборота.
                      Чем больше суммарный оборот ваших рефералов — тем выше ставка: от 0.75% до 1%.
                      Начисления в USDT, вывод — по запросу в поддержку.
                    </p>
                  </div>
                </div>
              </div>

              {/* Invited By */}
              {(referralData.invitedBy || referralData.invitedById) && (
                <div className="mt-4 bg-gray-800/30 rounded-xl p-3 border border-gray-700/30">
                  <p className="text-xs text-gray-500 text-center">
                    Вас пригласил: <span className="text-purple-400">
                      {referralData.invitedBy ? `@${referralData.invitedBy}` : referralData.invitedById}
                    </span>
                  </p>
                </div>
              )}
            </>
          ) : (
            <div className="bg-gray-800/50 rounded-2xl p-8 border border-gray-700/50 mb-4">
              <div className="text-center">
                <div className="bg-red-500/20 w-16 h-16 mx-auto mb-4 rounded-full flex items-center justify-center">
                  <AlertTriangle className="w-8 h-8 text-red-400" />
                </div>
                <h3 className="text-lg font-bold text-white mb-2">Ошибка загрузки</h3>
                <p className="text-gray-400 text-sm mb-4">Не удалось загрузить данные</p>
                <button
                  onClick={() => {
                    setReferralData(null);
                    setActiveSection('referral');
                  }}
                  className="px-4 py-2 bg-purple-600 hover:bg-purple-500 rounded-xl text-white text-sm font-medium transition-colors"
                >
                  Попробовать снова
                </button>
              </div>
            </div>
          )}
        </>
      )}

      {/* Stats Section */}
      {activeSection === 'stats' && (
        <>
          <SectionHeader title="Статистика" />
          
          {/* Summary Cards */}
          <div className="grid grid-cols-2 gap-3 mb-4">
            <div className="bg-gray-800/50 rounded-2xl p-4 border border-gray-700/50">
              <div className="flex items-center gap-3 mb-2">
                <div className="bg-purple-500/20 rounded-xl p-2">
                  <FileText className="w-5 h-5 text-purple-400" />
                </div>
                <span className="text-xs text-gray-400">Всего заявок</span>
              </div>
              <p className="text-3xl font-bold text-white">{stats.totalRequests || 0}</p>
            </div>
            
            <div className="bg-gray-800/50 rounded-2xl p-4 border border-gray-700/50">
              <div className="flex items-center gap-3 mb-2">
                <div className="bg-green-500/20 rounded-xl p-2">
                  <CheckCircle className="w-5 h-5 text-green-400" />
                </div>
                <span className="text-xs text-gray-400">Выполнено</span>
              </div>
              <p className="text-3xl font-bold text-green-400">{stats.completedRequests || 0}</p>
            </div>
          </div>

          {/* Volume Stats */}
          <div className="bg-gray-800/50 rounded-2xl p-4 border border-gray-700/50 mb-4">
            <h3 className="text-sm font-medium text-gray-400 mb-4">Общий объём операций</h3>
            
            <div className="space-y-4">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-yellow-500/20 rounded-xl flex items-center justify-center">
                    <span className="text-lg font-bold text-yellow-400">¥</span>
                  </div>
                  <div>
                    <p className="text-xs text-gray-500">Юани (CNY)</p>
                    <p className="text-xl font-bold text-white">{(stats.totalAmountCNY || 0).toLocaleString()}</p>
                  </div>
                </div>
              </div>
              
              <div className="border-t border-gray-700"></div>
              
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-blue-500/20 rounded-xl flex items-center justify-center">
                    <span className="text-lg font-bold text-blue-400">₽</span>
                  </div>
                  <div>
                    <p className="text-xs text-gray-500">Рубли (RUB)</p>
                    <p className="text-xl font-bold text-white">{(stats.totalAmountRUB || 0).toLocaleString()}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Status Breakdown */}
          <div className="bg-gray-800/50 rounded-2xl p-4 border border-gray-700/50 mb-4">
            <h3 className="text-sm font-medium text-gray-400 mb-4">По статусам</h3>
            
            <div className="space-y-3">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 rounded-full bg-green-400"></div>
                  <span className="text-sm text-gray-300">Выполнено</span>
                </div>
                <span className="text-sm font-semibold text-white">{stats.completedRequests || 0}</span>
              </div>
              
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 rounded-full bg-yellow-400"></div>
                  <span className="text-sm text-gray-300">В ожидании</span>
                </div>
                <span className="text-sm font-semibold text-white">{stats.pendingRequests || 0}</span>
              </div>
              
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 rounded-full bg-blue-400"></div>
                  <span className="text-sm text-gray-300">В обработке</span>
                </div>
                <span className="text-sm font-semibold text-white">{stats.processingRequests || 0}</span>
              </div>
              
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 rounded-full bg-red-400"></div>
                  <span className="text-sm text-gray-300">Отменено</span>
                </div>
                <span className="text-sm font-semibold text-white">{stats.cancelledRequests || 0}</span>
              </div>
            </div>
          </div>
        </>
      )}

      {/* Requests Section */}
      {activeSection === 'requests' && (
        <>
          <SectionHeader title="Мои заявки" />
          {/* Main Content Card */}
      <div className="bg-gray-800/50 rounded-2xl p-5 border border-gray-700/50">
        {/* Tabs */}
        <div className="flex gap-1 mb-5 bg-gray-900/50 rounded-xl p-1">
          <button
            onClick={() => setProfileTab('requests')}
            className={`flex-1 py-2.5 px-3 rounded-lg font-medium text-sm transition-all ${
              profileTab === 'requests'
                ? 'bg-purple-600 text-white'
                : 'text-gray-400 hover:text-white'
            }`}
          >
            <FileText className="w-4 h-4 inline mr-1.5" />
            Активные
          </button>
          <button
            onClick={() => setProfileTab('history')}
            className={`flex-1 py-2.5 px-3 rounded-lg font-medium text-sm transition-all ${
              profileTab === 'history'
                ? 'bg-purple-600 text-white'
                : 'text-gray-400 hover:text-white'
            }`}
          >
            <History className="w-4 h-4 inline mr-1.5" />
            История
          </button>
        </div>

        {/* Tab Content */}
        <div>
          {profileTab === 'requests' && (
            <div>
              {(() => {
                const activeRequests = requests.filter(
                  req => req.status !== 'completed' && req.status !== 'cancelled'
                );
                
                return (
                  <>
                    {activeRequests.length === 0 ? (
                      <div className="text-center py-8">
                        <div className="bg-gray-700/30 rounded-full w-16 h-16 mx-auto mb-3 flex items-center justify-center">
                          <FileText className="w-8 h-8 text-gray-600" />
                        </div>
                        <p className="text-gray-400 font-medium">Нет активных заявок</p>
                        <p className="text-sm text-gray-600 mt-1">Создайте новую заявку</p>
                      </div>
                    ) : (
                      <div className="space-y-2">
                        {activeRequests.map((request) => (
                          <button
                            key={request.id}
                            onClick={() => {
                              const orderData = {
                                orderId: request.id,
                                type: request.type,
                                amount: request.amount,
                                paymentMethod: request.paymentMethod,
                                bank: request.bank || '',
                                network: request.network || '',
                                fullName: request.fullName || '',
                                status: request.status,
                                paymentDetails: request.paymentDetails,
                              };
                              setOrderDetails(orderData);
                              setCurrentScreen('orderConfirmation');
                            }}
                            className="w-full bg-gray-700/30 rounded-xl p-4 hover:bg-gray-700/50 transition-all text-left group"
                          >
                            <div className="flex justify-between items-center">
                              <div className="flex items-center gap-3">
                                <div className={`w-10 h-10 rounded-xl flex items-center justify-center ${
                                  request.type === 'Alipay' 
                                    ? 'bg-blue-500/20' 
                                    : 'bg-green-500/20'
                                }`}>
                                  <Wallet className={`w-5 h-5 ${
                                    request.type === 'Alipay' ? 'text-blue-400' : 'text-green-400'
                                  }`} />
                                </div>
                                <div>
                                  <p className="font-semibold text-white group-hover:text-purple-300 transition-colors">
                                    {request.amount} ¥
                                  </p>
                                  <p className="text-xs text-gray-500">
                                    № {request.id}
                                  </p>
                                </div>
                              </div>
                              <span className={`px-2.5 py-1 rounded-lg text-xs font-medium ${
                                request.status === 'pending' 
                                  ? 'bg-yellow-500/20 text-yellow-400'
                                  : request.status === 'processing'
                                  ? 'bg-blue-500/20 text-blue-400'
                                  : request.status === 'paid'
                                  ? 'bg-green-500/20 text-green-400'
                                  : 'bg-gray-700 text-gray-400'
                              }`}>
                                {request.status === 'pending' ? 'Ожидает' : 
                                 request.status === 'processing' ? 'Обработка' :
                                 request.status === 'paid' ? 'Оплачено' :
                                 request.status}
                              </span>
                            </div>
                          </button>
                        ))}
                      </div>
                    )}
                  </>
                );
              })()}
            </div>
          )}

          {profileTab === 'history' && (
            <div>
              {history.length === 0 ? (
                <div className="text-center py-8">
                  <div className="bg-gray-700/30 rounded-full w-16 h-16 mx-auto mb-3 flex items-center justify-center">
                    <History className="w-8 h-8 text-gray-600" />
                  </div>
                  <p className="text-gray-400 font-medium">История пуста</p>
                  <p className="text-sm text-gray-600 mt-1">Завершённые операции появятся здесь</p>
                </div>
              ) : (
                <div className="space-y-2">
                  {history.map((item) => (
                    <div 
                      key={item.id} 
                      className="bg-gray-700/30 rounded-xl p-4"
                    >
                      <div className="flex justify-between items-center">
                        <div className="flex items-center gap-3">
                          <div className={`w-10 h-10 rounded-xl flex items-center justify-center ${
                            item.type === 'Alipay' 
                              ? 'bg-blue-500/20' 
                              : 'bg-green-500/20'
                          }`}>
                            <Wallet className={`w-5 h-5 ${
                              item.type === 'Alipay' ? 'text-blue-400' : 'text-green-400'
                            }`} />
                          </div>
                          <div>
                            <p className="font-semibold text-white">{item.amount} ¥</p>
                            <p className="text-xs text-gray-500">{item.date}</p>
                          </div>
                        </div>
                        <div className="text-right">
                          <p className="font-semibold text-green-400">{item.rub || '—'} ₽</p>
                          <div className="flex items-center gap-1 justify-end">
                            <CheckCircle className="w-3 h-3 text-green-500" />
                            <span className="text-xs text-green-500">Выполнено</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}

        </div>
      </div>
        </>
      )}
    </div>

    {/* KYC Modal */}
    <KYCModal
      isOpen={isKYCModalOpen}
      onClose={() => setIsKYCModalOpen(false)}
      tg={tg}
      setUserPhone={setUserPhone}
      uploadDocument={uploadDocument}
      registerClient={registerClient}
      sendVerificationCode={sendVerificationCode}
      confirmVerification={confirmVerification}
      checkVerificationStatus={checkVerificationStatus}
      apiUrl={apiUrl}
      userId={userId}
    />
  </div>
  );
};

export default ProfileScreen;
